module.exports = __webpack_public_path__ + "static/img/print.47434721.png";